import careersRoutes from "../config/careersRoutes.json";

export const careersRoutesEnabled = careersRoutes.enabled;

export const isCareersOrJobsPath = (pathname) =>
  /\/(careers|jobs)(\/|$)/.test(pathname || "");
